import React, { useState, useEffect, useRef, useMemo } from "react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { withSafeMarkdownUrls } from "src/Ateam-BI/utils/safeMarkdown";

// Built once: a new components object on every render would make react-markdown remount these subtrees.
const MARKDOWN_COMPONENTS = withSafeMarkdownUrls({
  table: ({ node, ...props }) => (
    <div style={{ margin: '40px 0', overflowX: 'auto' }}>
      <table
        {...props}
        style={{
          borderCollapse: 'collapse',
          width: '100%',
        }}
      />
    </div>
  ),
  th: ({ node, ...props }) => (
    <th
      {...props}
      style={{
        padding: '5px 8px',
        border: '1px solid #ddd',
        backgroundColor: '#f5f5f5',
        textAlign: 'left'
      }}
    />
  ),
  td: ({ node, ...props }) => (
    <td
      {...props}
      style={{
        padding: '5px 8px',
        border: '1px solid #ddd',
        textAlign: 'left'
      }}
    />
  ),
  tr: ({ node, ...props }) => (
    <tr {...props} style={{ borderBottom: '1px solid #ddd' }} />
  )
});

const ReactMarkdownRenderer = (props) => {


  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={MARKDOWN_COMPONENTS}>
      {props.content}
    </ReactMarkdown>
  );
};

export default ReactMarkdownRenderer;
